var emitter = require('./base/emitter'),
	common = require('./base/common'),
	
	Events = require('./base/events'),
	events = new Events(),

	Scroller = require('./components/scroller'),
	scroller = new Scroller(),

	Form = require('./components/form'),

	Home = require('./layouts/home'),
	home = new Home(),

	Linee = require('./layouts/linee'),
	linee = new Linee(),

	Contacts = require('./layouts/contacts'),
	contacts = new Contacts(),

	Header = require('./layouts/header.js'),
	header = new Header(),

	Loader = require('./layouts/loader'),
	loader = new Loader(),

	Navigator = require('./layouts/navigator'),
	navigator = new Navigator();

$('.c-form').each(function(){
	new Form($(this));
})

$(window).on('touchstart', function(e){

	if($('body').hasClass('no-scroll')) e.preventDefault();

})

emitter.emit('app:init');

// common.$window.on('load', function loadEvent() {
//     emitter.emit('page:load');
// });

common.$window.on('resize', _.debounce(function resizeEvent() {
    emitter.emit('page:resize');
}, 100));

common.$window.on('scroll', function() {
    emitter.emit('page:scroll');
})



/** WEBPACK FOOTER **
 ** ./app.js
 **/